import React, { useImperativeHandle } from 'react';
import { i18n } from 'fishx';

import { Form } from '@whalecloud/fdx';
import FNFMember from '@/components/PortalDSCM/FNFMember';

const FMCForm = props => {
  const { form, refInstance, modelKey, tabKey, activeDepPlanPanels, onCollapseChange } = props;
  const { getFieldDecorator, validateFields } = form;

  useImperativeHandle(refInstance, () => ({
    getFNFfellowNbrList,
  }));

  const getFNFfellowNbrList = async() => {
    const { fellowNbrFNFList } = await validateFields((err, value) => {
      if (err) {
        activeDepPlanPanels.push(tabKey);
        onCollapseChange([...new Set(activeDepPlanPanels)]); // 去重
      }
    });
    const attrList = fellowNbrFNFList?.map(item => {
      const { subsId, key, ...otherItem } = item;
      otherItem.operationType = 'A';
      if (subsId) {
        otherItem.subsId = subsId;
      }
      return otherItem;
    });
    return attrList || [];
  };

  return (
    <Form layout="inline">
      <Form.Item label={i18n('FNF_MEMBER')}>
        {getFieldDecorator('fellowNbrFNFList', {
          rules: [{
            required: true,
            message: i18n('COMMON_PLEASE_SELECT'),
          }],
        })(
          <FNFMember modelKey={modelKey} />
        )}
      </Form.Item>
    </Form>
  );
};

const Component = Form.create({
  onValuesChange: (props, changedValues, allValues) => {
    const { fellowNbrFNFList } = allValues;
    const attrList = (fellowNbrFNFList || []).map(item => {
      const { subsId, key, ...otherItem } = item;
      otherItem.operationType = 'A';
      if (subsId) {
        otherItem.subsId = subsId;
      }
      return otherItem;
    });
    const { onChange } = props;
    onChange(attrList);
  },
})(FMCForm);

export default React.forwardRef((props, ref) => <Component {...props} refInstance={ref} />);
